<script lang="ts">
  import { workExperiences } from './data';
</script>

<section class="mt-2 md:mt-0 print:mt-0">
  <h2 class="text-2xl uppercase print:text-lg print:mb-1">Work Experience</h2>
  <hr />
  <ul class="text-left">
    {#each workExperiences as exp}
      <li class="print:mb-2">
        <div class="flex justify-between">
          <h4 class="text-base md:text-xl font-bold print:text-sm">
            {exp.company}
          </h4>
          <h4 class="text-base md:text-xl font-bold print:text-sm">
            {exp.location}
          </h4>
        </div>
        <div class="flex justify-between">
          <h4
            class="mt-2 md:mt-0 text-xs md:text-base italic print:text-xs print:mt-0"
          >
            {exp.title}
          </h4>
          <h4
            class="mt-2 md:mt-0 text-xs md:text-base print:text-xs print:mt-0"
          >
            {exp.dateRange}
          </h4>
        </div>
        <ul class="list-disc list-inside pl-4 print:pl-2">
          {#each exp.descriptions as desc, idx}
            {#if idx === 0}
              <li
                class="text-sm mt-2 mb-2 md:mt-0 md:mb-0 md:text-base print:text-xs print:mb-0 print:mt-0"
              >
                {@html desc}
              </li>
            {:else}
              <li
                class="text-sm mb-2 md:mb-0 md:text-base print:text-xs print:mb-0"
              >
                {@html desc}
              </li>
            {/if}
          {/each}
        </ul>
      </li>
    {/each}
  </ul>
</section>
